import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IbBoxInfoModule } from './components/ib-box-info/ib-box-info.module';
import { IbGenericHeaderModule } from './components/generic-header/ib-generic-header.module';
import { IbGenericFooterModule } from './components/ib-generic-footer/ib-generic-footer.module';
import { CustomCurrencyPipe } from './pipes/CustomCurrency.pipe';





@NgModule({
    declarations: [
        CustomCurrencyPipe
    ],
    imports: [
        CommonModule,
        IbGenericHeaderModule,
        TranslateModule,
        IbBoxInfoModule,
        IbGenericFooterModule
    ],
    exports: [
        IbGenericHeaderModule,
        TranslateModule,
        IbBoxInfoModule,
        IbGenericFooterModule,
        CustomCurrencyPipe
    ]
})
export class SharedModule {
    static entryComponents = [
        IbGenericHeaderModule
    ];
}
